import React, { useState, useEffect, useRef, useCallback } from "react";

const BurgerNav = () => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const burgerRef = useRef(null);
    const closeRef = useRef(null);

    const closeMenu = useCallback(() => setIsOpen(false), []);

    // Focus close button when menu opens, return focus to burger when it closes
    useEffect(() => {
        if (isOpen) {
            closeRef.current?.focus();
        } else {
            burgerRef.current?.focus();
        }
    }, [isOpen]);

    // Escape key closes the menu
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                closeMenu();
                return;
            }

            // Focus trap: keep Tab within the menu
            if (e.key === 'Tab') {
                const focusable = menuRef.current?.querySelectorAll(
                    'button, a[href]'
                );
                if (!focusable || focusable.length === 0) return;

                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, closeMenu]);

    return (
        <div className="hidden max-md:block">
            <button
                ref={burgerRef}
                className="burger-btn fixed right-9 top-9 w-9 h-[30px] bg-transparent border-none cursor-pointer z-[1100] flex flex-col justify-between p-0"
                onClick={() => setIsOpen(true)}
                aria-label="Open menu"
                aria-expanded={isOpen}
            >
                <span className="block w-full h-1 bg-white rounded-sm" />
                <span className="block w-full h-1 bg-white rounded-sm" />
                <span className="block w-full h-1 bg-white rounded-sm" />
            </button>

            {isOpen && (
                <div className="fixed inset-0 bg-black/30 z-[1000]" onClick={closeMenu} />
            )}

            <div
                ref={menuRef}
                role="dialog"
                aria-label="Navigation menu"
                aria-hidden={!isOpen}
                className={`fixed top-0 right-0 w-[300px] h-full bg-[#373a47] z-[1100] transition-transform duration-300 ease-in-out pt-10 px-6 box-border ${isOpen ? "translate-x-0" : "translate-x-full"}`}
            >
                <button
                    ref={closeRef}
                    className="absolute right-4 top-4 bg-transparent border-none text-[#bdc3c7] text-[28px] cursor-pointer p-0 leading-none"
                    onClick={closeMenu}
                    aria-label="Close menu"
                >
                    &times;
                </button>
                <nav className="flex flex-col p-[0.8em]">
                    <a className="inline-block mb-5 text-xl text-[#c8c7c7] no-underline" href="#home" onClick={closeMenu}>Home</a>
                    <a className="inline-block mb-5 text-xl text-[#c8c7c7] no-underline" href="#exp" onClick={closeMenu}>Experience</a>
                    <a className="inline-block mb-5 text-xl text-[#c8c7c7] no-underline" href="#projects" onClick={closeMenu}>Projects</a>
                    <a className="inline-block mb-5 text-xl text-[#c8c7c7] no-underline" href="#about" onClick={closeMenu}>About</a>
                    <a className="inline-block mb-5 text-xl text-[#c8c7c7] no-underline" href="#contact" onClick={closeMenu}>Contact</a>
                </nav>
            </div>
        </div>
    );
};

export default BurgerNav;
